<script>
    export let pageChanged
    export let url
    export let pager

    $: prevPages = [
        pager.currentPage - 5,
        pager.currentPage - 4,
        pager.currentPage - 3,
        pager.currentPage - 2,
        pager.currentPage - 1,
    ].filter((p) => p >= pager.firstPage)

    $: nextPages = [
        pager.currentPage + 1,
        pager.currentPage + 2,
        pager.currentPage + 3,
        pager.currentPage + 4,
        pager.currentPage + 5,
    ].filter((p) => p <= pager.lastPage)

    $: prevPage = pager.currentPage - 1
    $: nextPage = pager.currentPage + 1
    $: hasPrev = pager.currentPage > pager.firstPage
    $: hasNext = pager.currentPage < pager.lastPage
    $: showFirstPage = pager.currentPage >= 6
    $: showLastPage = pager.lastPage - pager.currentPage >= 6

    const changePage = async (e, page) => {
        e.preventDefault()
        const newUrl = `${url}&page=${page}`
        const response = await fetch(newUrl)
        const json = await response.json()

        pageChanged(json)
    }
</script>

<div class="pagination-centered">
    <ul class="pagination pagination-sm">
        {#if showFirstPage}
            <li on:click={(e) => changePage(e, 1)}>
                <a href="#">Eerste</a>
            </li>
        {/if}
        <li class:disabled={!hasPrev} on:click={(e) => changePage(e, prevPage)}>
            <a title="Previous" href="#">« </a>
        </li>
        {#each prevPages as prevPage}
            <li on:click={(e) => changePage(e, prevPage)}>
                <a href="#">{prevPage}</a>
            </li>
        {/each}

        <li class="active">
            <a href="#">{pager.currentPage}</a>
        </li>

        {#each nextPages as nextPage}
            <li on:click={(e) => changePage(e, nextPage)}>
                <a href="#">{nextPage}</a>
            </li>
        {/each}

        <li class:disabled={!hasNext} on:click={(e) => changePage(e, nextPage)}>
            <a title="Next" href="#">» </a>
        </li>
        {#if showLastPage}
            <li on:click={(e) => changePage(e, pager.lastPage)}>
                <a href="#">Laatste</a>
            </li>
        {/if}
    </ul>
</div>
